import React, { useEffect } from "react";
import { Grid, Backdrop, CircularProgress } from "@material-ui/core";
import { Breadcrumb } from "components/breadCrumb";
import { PageTitle } from "components/pageTitle";
import { OrganizationalLink, Text } from "./organizationalStructure.styles";
import { Wrapper } from "components/wrapper";
import { useOrganizationalStructureState } from "./context/organizational-structure-context";
import { useOrganizationalStructureController } from "./context/organizational-structure-controller";
import Document from "assets/icons/services-icons/document.svg";

export const OrganizationalStructurePage = () => {
  const { governamentalStructures, loading } = useOrganizationalStructureState();
  const { onInit } = useOrganizationalStructureController();

  useEffect(() => {
    onInit();
  }, [onInit]);

  return (
    <>
      <Breadcrumb
        items={[
          { label: "Home", href: "/" },
          { label: "Estrutura Organizacional" },
        ]}
      />
      <PageTitle>ESTRUTURA ORGANIZACIONAL</PageTitle>
      <Wrapper>
        <Grid container spacing={3}>
          {governamentalStructures.map((structure) => (
            <Grid key={structure.id} item xs={12} md={6}>
              <OrganizationalLink href={`/estrutura-organizacional/${structure.id}`}>
                <Grid container spacing={2} alignItems="center">
                  <Grid item xs="auto">
                    <img src={Document} alt={structure.person} />
                  </Grid>
                  <Grid item xs>
                    <Text>{structure.person}</Text>
                  </Grid>
                </Grid>
              </OrganizationalLink>
            </Grid>
          ))}
        </Grid>
      </Wrapper>
      <Backdrop open={loading} style={{ zIndex: 1000 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </>
  );
};
